<!-- Tc7Certification -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอต่ออายุใบอนุญาต
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['ตรวจสอบข้อมูล', 'อัปโหลดเอกสาร', 'ยืนยันการทำรายการ', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="0" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>

                <div class="container py-3 page font-family-bla">
                    <!-- กล่องเงื่อนไขก้อนที่ 1 -->
                    <div class="rounded-bla border-bla p-3 mb-2">
                        <div class="scroll-box" ref="agreementBox" @scroll="checkScrollEnd">
                            <p class="mb-2">
                                ขอรับรองว่าข้าพเจ้ามีคุณสมบัติครบถ้วนและไม่มีลักษณะต้องห้ามตามพระราชบัญญัติประกันชีวิต
                                พ.ศ. ๒๕๓๕ และที่แก้ไขเพิ่มเติม และกฎหมายที่เกี่ยวข้อง ดังนี้
                            </p>
                            <ol class="thai-main">
                                <li>มีคุณสมบัติดังต่อไปนี้
                                    <ol class="thai-sub">
                                        <li>บรรลุนิติภาวะ</li>
                                        <li>มีภูมิลำเนาในประเทศไทย</li>
                                        <li>ได้รับการศึกษาวิชาประกันชีวิตตามที่สำนักงานประกาศกำหนด
                                            หรือสอบความรู้เกี่ยวกับการประกันชีวิตได้ตามหลักสูตร วิธีการ
                                            และเงื่อนไขที่สำนักงานประกาศกำหนด</li>
                                    </ol>
                                </li>
                                <li>ไม่มีลักษณะต้องห้ามดังต่อไปนี้
                                    <ol class="thai-sub">
                                        <li>เป็นคนวิกลจริตหรือจิตฟั่นเฟือนไม่สมประกอบ
                                            คนไร้ความสามารถหรือคนเสมือนไร้ความสามารถ</li>
                                        <li>เคยต้องคำพิพากษาถึงที่สุดว่ากระทำความผิดเกี่ยวกับทรัพย์ที่กระทำโดยทุจริต
                                            เว้นแต่ได้พ้นโทษมาแล้วไม่น้อยกว่าห้าปีก่อนวันยื่นคำขอรับใบอนุญาต</li>
                                        <li>เป็นบุคคลล้มละลายหรือเคยเป็นบุคคลล้มละลายทุจริต</li>
                                        <li>เป็นนายหน้าประกันชีวิต</li>
                                        <li>อยู่ระหว่างถูกสั่งพักใช้ใบอนุญาตเป็นตัวแทนประกันชีวิต
                                            หรือใบอนุญาตเป็นนายหน้าประกันชีวิต หรือใบอนุญาตเป็นตัวแทนประกันวินาศภัย
                                            หรือใบอนุญาตเป็นนายหน้าประกันวินาศภัย ตามกฎหมายว่าด้วยประกันวินาศภัย</li>
                                        <li>เคยถูกเพิกถอนใบอนุญาตเป็นตัวแทนประกันชีวิต
                                            หรือใบอนุญาตเป็นนายหน้าประกันชีวิต หรือใบอนุญาตเป็นตัวแทนประกันวินาศภัย
                                            หรือใบอนุญาตเป็นนายหน้าประกันวินาศภัยตามกฎหมายว่าด้วยประกันวินาศภัย
                                            และยังไม่พ้นกำหนด ห้าปีนับถึงวันยื่นคำขอรับใบอนุญาต</li>
                                        <li>มีประวัติเสียหายหรือแสดงถึงการขาดความรับผิดชอบ ดังต่อไปนี้
                                            <ol class="thai-alpha">
                                                <li>เป็นบุคคลที่ถูกกำหนดตามกฎหมายว่าด้วยการป้องกันและปราบปรามการสนับสนุนทางการเงิน
                                                    แก่การก่อการร้าย และการแพร่ขยายอาวุธที่มีอานุภาพทำลายล้างสูง
                                                </li>
                                                <li>เป็นผู้ที่ศาลมีคำสั่งให้ทรัพย์สินตกเป็นของแผ่นดินตามกฎหมายเกี่ยวกับการป้องกันและ
                                                    ปราบปรามการทุจริต กฎหมายว่าด้วยการป้องกันและปราบปรามการฟอกเงิน
                                                    หรือกฎหมายอื่น
                                                    ในลักษณะเดียวกัน และยังไม่พ้นกำหนด
                                                    ห้าปีนับแต่วันที่ศาลสั่งให้ทรัพย์สินตกเป็นของแผ่นดิน
                                                </li>
                                                <li>เคยถูกไล่ออก ปลดออก หรือให้ออกจากราชการ รัฐวิสาหกิจ องค์การ
                                                    หน่วยงานของรัฐ หรือ
                                                    หน่วยงานเอกชน เพราะทุจริตต่อหน้าที่
                                                    และยังไม่พ้นกำหนดห้าปีนับแต่วันที่ไล่ออก ปลดออก
                                                    หรือให้ออก</li>
                                                <li>เคยถูกลงโทษหรือต้องคำพิพากษาถึงที่สุดว่ากระทำความผิดตามมาตรา ๑๑๔/๓
                                                    มาตรา ๑๑๔/๔
                                                    มาตรา ๑๑๔/๕ ตามกฎหมายว่าด้วยประกันชีวิต มาตรา ๑๐๘/๓ มาตรา ๑๐๘/๔
                                                    มาตรา ๑๐๘
                                                    /๕ ตามกฎหมายว่าด้วยประกันวินาศภัย และมาตรา ๓๔๗ ตามประมวลกฎหมายอาญา
                                                    เว้นแต่
                                                    ได้พ้นโทษมาแล้วไม่น้อยกว่าห้าปีก่อนวันยื่นคำขอรับใบอนุญาต
                                                </li>
                                                <li>กระทำความผิดที่เกี่ยวกับการทุจริตในการปฏิบัติหน้าที่ตามกฎหมายเกี่ยวกับการประกันภัย
                                                    การเงิน การลงทุน และการ คุ้มครองผู้บริโภค
                                                    ไม่ว่าในประเทศหรือต่างประเทศ เว้นแต่ได้พ้นโทษ
                                                    มาแล้วไม่น้อยกว่าห้าปีก่อนวันยื่นคำขอรับ ใบอนุญาต
                                                </li>
                                                <li>เคยถูกถอดถอนจากการเป็นกรรมการหรือบุคคลซึ่งรับผิดชอบในการดำเนินงานของบริษัทตาม
                                                    กฎหมายว่าด้วยประกันชีวิต
                                                    หรือเคยถูกถอดถอนจากการเป็นกรรมการหรือบุคคลซึ่งรับผิดชอบ
                                                    ในการดำเนินงานของบริษัทตามกฎหมาย ว่าด้วยประกันวินาศภัย
                                                    และยังไม่พ้นกำหนดห้าปีนับ
                                                    ถึงวันยื่นคำขอรับใบอนุญาต
                                                </li>
                                                <li>เป็นหรือเคยเป็นผู้มีหน้าที่รับผิดชอบในการดำเนินงานเกี่ยวกับการเป็นนายหน้าประกันชีวิตตาม
                                                    กฎหมายว่าด้วย ประกันชีวิต
                                                    หรือนายหน้าประกันวินาศภัยตามกฎหมายว่าด้วยประกันวินาศ
                                                    ภัยของนิติบุคคลในขณะที่ถูกเพิกถอน ใบอนุญาต
                                                    และยังไม่พ้นกำหนดห้าปีนับถึงวันยื่นคำ
                                                    ขอรับใบอนุญาต เว้นแต่พิสูจน์ได้ว่าไม่มีส่วนเกี่ยวข้องกับเหตุแห่ง
                                                    การเพิกถอนใบอนุญาตนั้น
                                                </li>
                                                <li>มีหรือเคยมีพฤติกรรมประพฤติผิดต่อหน้าที่ หรือส่อไปในทางไม่สุจริต
                                                    หรือขาดความซื่อสัตย์และ
                                                    เป็นธรรม ขาดความรับผิดชอบและความรอบคอบ เอาเปรียบ
                                                    หรือขาดจรรยาบรรณหรือ
                                                    มาตรฐานในการปฏิบัติงาน
                                                    เยี่ยงผู้ประกอบวิชาชีพที่ส่งผลกระทบต่อความน่าเชื่อถือในการ
                                                    เป็นตัวแทนประกันชีวิต หรือนายหน้าประกันชีวิต
                                                    ตามกฎหมายว่าด้วยประกันชีวิต หรือ
                                                    ตัวแทนประกันวินาศภัย หรือนายหน้าประกันวินาศภัยตามกฎหมายว่าด้วย
                                                    ประกันวินาศภัย
                                                    หรือมีหรือเคยมีส่วนร่วม หรือสนับสนุนการกระทำดังกล่าวของบุคคลอื่น
                                                    เว้นแต่ปรากฏ
                                                    ข้อเท็จจริง
                                                    ว่าพฤติกรรมนั้นเกิดขึ้นมาแล้วไม่น้อยกว่าห้าปีนับถึงวันยื่นคำขอรับใบอนุญาต
                                                </li>
                                            </ol>
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <!-- เช็คบ็อกซ์ 1 -->
                    <div class="d-flex align-items-start gap-3 mb-4">
                        <div class="form-check form-check-bla">
                            <input id="agree1" class="form-check-input" type="checkbox" v-model="agree1"
                                :disabled="checkboxDisabled">
                        </div>
                        <label class="form-check-label mt-1" for="agree1">
                            ข้าพเจ้าขอรับรองว่าข้อความที่แถลงข้างต้นและเอกสารประกอบที่ได้แสดงต่อนายทะเบียนถูกต้องเป็นความจริงทุกประการ
                        </label>
                    </div>

                    <!-- คำรับรองคุณสมบัติ -->
                    <div v-if="this.isRegisUnitLink && this.isRenewAgentRegis">

                        <h5 class="text-center fw-bold my-3">
                            คำรับรองคุณสมบัติ<br>
                            ผู้ยื่นคำขอต่ออายุการขึ้นทะเบียนตัวแทนประกันชีวิตควบการลงทุน
                        </h5>

                        <!-- กล่องเงื่อนไขก้อนที่ 2 -->
                        <div class="rounded-bla border-bla p-3 mb-2">
                            <div class="scroll-box">
                                <p class="mb-2">ข้าพเจ้าขอรับรองว่าข้าพเจ้ามีคุณสมบัติดังต่อไปนี้</p>
                                <ul class="thai-sub">
                                    <li>เป็นผู้ได้รับใบอนุญาตเป็นตัวแทนประกันชีวิตหรือนายหน้าประกันชีวิตประเภทบุคคลธรรมดา
                                    </li>
                                    <li>เป็นผู้ได้รับความเห็นชอบตามประกาศสำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์
                                        (ก.ล.ต)</li>
                                    <li>ผ่านการอบรมความรู้เกี่ยวกับกรมธรรม์ประกันชีวิตควบการลงทุน
                                        ตามหลักสูตรที่สำนักงานประกาศกำหนด</li>
                                </ul>
                            </div>
                        </div>

                        <!-- เช็คบ็อกซ์ 2 -->
                        <div class="d-flex align-items-start gap-3 mb-3">
                            <div class="form-check form-check-bla">
                                <input id="agree2" class="form-check-input" type="checkbox" v-model="agree2">
                            </div>
                            <label class="form-check-label mt-1" for="agree2">
                                ข้าพเจ้าขอรับรองว่า
                                มีคุณสมบัติครบถ้วนในการเป็นตัวแทนประกันชีวิตควบการลงทุนหรือนายหน้าประกันชีวิตควบการลงทุนและข้อความข้างต้นพร้อมเอกสารประกอบถูกต้องเป็นความจริง
                                และตกลงที่จะปฏิบัติตามหลักเกณฑ์ในการเป็นตัวแทนประกันชีวิตควบการลงทุนหรือนายหน้าประกันชีวิตควบการลงทุนตามที่สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย
                                (คปภ.) กำหนดทุกประการ
                            </label>
                        </div>
                    </div>

                    <!-- ปุ่ม -->
                    <div class="d-flex justify-content-center gap-3 mt-4">
                        <button type="button" class="btn btn-secondary btn-confirm" @click="goBack">ย้อนกลับ</button>
                        <button type="button" class="btn btn-bla btn-confirm" :disabled="!canNext" @click="next">
                            ถัดไป
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import StepBar from "./StepBar.vue";

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: "Tc7Certification",
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            Loading: true,
            agree1: false,// อ่านคำรับรองคุณสมบัติ ตช.7
            agree2: false,// รับรองคุณสมบัติ
            checkboxDisabled: true,// เริ่มต้นปิด checkbox
            isRegisUnitLink: false,// ต้องการต่อทะเบียนขาย Unit-Linked หรือไม่?
            isRenewAgentRegis: false,
        };
    },
    computed: {
        canNext() {
            return this.agree1 && (
                (this.isRegisUnitLink && this.isRenewAgentRegis && this.agree2) ||

                (this.isRegisUnitLink && !this.isRenewAgentRegis) ||

                (!this.isRegisUnitLink)
            );
        }
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.BindingData();// แสดงข้อมูล
    },
    methods: {
        BindingData() {
            this.isRegisUnitLink = this.$store.state.AgentRenewLicense.preview.isRegisUnitLink;
            this.isRenewAgentRegis = this.$store.state.AgentRenewLicense.preview.isRenewAgentRegis;
        },
        goBack() {
            this.$store.state.AgentRenewLicense.tc7Cert.agree1 = false;
            this.$store.state.AgentRenewLicense.tc7Cert.agree1_Date = null;
            this.$store.state.AgentRenewLicense.tc7Cert.agree2 = false;
            this.$store.state.AgentRenewLicense.tc7Cert.agree2_Date = null;

            this.$router.replace('/PreviewAgentRenewLicense');
        },
        next() {
            // ไปหน้าถัดไปเมื่อเช็คถูกครบ
            if (this.agree1 && (
                (this.isRegisUnitLink && this.isRenewAgentRegis && this.agree2) ||
                (this.isRegisUnitLink && !this.isRenewAgentRegis) ||
                (!this.isRegisUnitLink)
            )) {
                const currentDate = new Date().toLocaleString('th-TH');

                this.$store.state.AgentRenewLicense.tc7Cert.agree1 = this.agree1;
                this.$store.state.AgentRenewLicense.tc7Cert.agree1_Date = currentDate;
                this.$store.state.AgentRenewLicense.tc7Cert.agree2 = this.agree2;
                this.$store.state.AgentRenewLicense.tc7Cert.agree2_Date = currentDate;

                this.$router?.replace?.('/UploadFileAgentRenewLicense')// อัพโหลดเอกสาร
            }
        },
        checkScrollEnd() {
            const box = this.$refs.agreementBox;
            const isBottom = box.scrollTop + box.clientHeight >= box.scrollHeight - 2;
            if (isBottom) {
                this.checkboxDisabled = false; // เมื่อ scroll ถึงล่างสุด
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    },
};
</script>

<style scoped>
/* ปุ่ม: เต็มความกว้างบนมือถือ และกว้างพอดีบนจอใหญ่ */
.btn-confirm {
    width: 100%;
}

@media (min-width: 768px) {
    .btn-confirm {
        width: 25%;
        min-width: 160px;
        max-width: 320px;
    }
}

/* ===== ลำดับเลขไทย & อักษรไทย ===== */
/* ชั้นหลัก -> ๑. ๒. ๓. */
.thai-main {
    list-style: none;
    counter-reset: main;
    padding-left: 1.6em;
}

.thai-main>li {
    counter-increment: main;
    margin-bottom: .25rem;
}

.thai-main>li::marker {
    content: counter(main, thai) ". ";
}

/* ชั้นย่อย -> (๑) (๒) (๓) */
.thai-sub {
    list-style: none;
    counter-reset: sub;
    padding-left: 2em;
}

.thai-sub>li {
    counter-increment: sub;
}

.thai-sub>li::marker {
    content: "(" counter(sub, thai) ") ";
}

/* ชั้นอักษรไทย -> (ก) (ข) (ค) */
@counter-style thai-alpha {
    system: alphabetic;
    symbols: "ก" "ข" "ค" "ง" "จ" "ฉ" "ช" "ซ";
    prefix: "(";
    suffix: ") ";
}

.thai-alpha {
    list-style: thai-alpha;
    padding-left: 2em;
}

/* ฟอนต์และพื้นฐาน */
.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

/* กรอบสีน้ำเงินอ่อน โค้งมน */
.border-bla {
    border: 2px solid #A2B9E2;
}

.rounded-bla {
    border-radius: 12px;
}

/* กล่องข้อความเลื่อนอ่านได้ */
.scroll-box {
    max-height: 220px;
    /* ปรับให้ใกล้ภาพ */
    overflow: auto;
    padding: .25rem .5rem;
}

/* เช็คบ็อกซ์ทรงสี่เหลี่ยม */
.form-check-bla .form-check-input {
    width: 26px;
    height: 26px;
    border: 2px solid #6C757D;
    border-radius: 4px;
    /* สี่เหลี่ยมมนเล็กน้อย */
    margin-top: .1rem;
}

.form-check-bla .form-check-input:checked {
    background-color: #0d6efd;
    border-color: #0d6efd;
}

/* ปุ่มทรง pill ตรงกลางเหมือนภาพ */
.btn-pill {
    border-radius: 999px;
    padding: .6rem 1.6rem;
    min-width: 140px;
}

/* ขนาดตัวอักษรและระยะหายใจให้ใกล้ภาพ */
.page {
    font-size: 1.02rem;
    line-height: 1.65;
}

ol,
ul {
    margin-bottom: 0.25rem;
}
</style>
